var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRemoveCollection(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.126,
    height: 22.126,
    viewBox: "0 0 29.836 29.835",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6360",
    "data-name": "Group 6360",
    transform: "translate(17380.5 495.998)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5854",
    "data-name": "Path 5854",
    d: "M27.3,7.325H24.51V4.53A3.53,3.53,0,0,0,20.98,1H4.53A3.53,3.53,0,0,0,1,4.53V20.98a3.53,3.53,0,0,0,3.53,3.53H7.325V27.3a3.53,3.53,0,0,0,3.53,3.53H27.3a3.53,3.53,0,0,0,3.53-3.53V10.856a3.53,3.53,0,0,0-3.53-3.53Zm-19.98,3.53V22.521H4.53A1.541,1.541,0,0,1,2.989,20.98V4.53A1.532,1.532,0,0,1,4.53,2.989H20.98A1.541,1.541,0,0,1,22.521,4.53V7.325H10.856a3.53,3.53,0,0,0-3.53,3.53ZM28.846,27.3A1.532,1.532,0,0,1,27.3,28.846H10.856A1.541,1.541,0,0,1,9.314,27.3V10.856a1.551,1.551,0,0,1,1.541-1.541H27.3a1.541,1.541,0,0,1,1.541,1.541Z",
    transform: "translate(-17381.5 -496.998)",
    fill: "#fc7886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5855",
    "data-name": "Path 5855",
    d: "M28.547,20.127H22.892V14.473a1.383,1.383,0,1,0-2.765,0v5.655H14.473a1.383,1.383,0,1,0,0,2.765h5.655v5.655a1.383,1.383,0,0,0,2.765,0V22.892h5.655a1.383,1.383,0,0,0,0-2.765Z",
    transform: "translate(-17392.99 -478.07) rotate(-45)",
    fill: "#fc7886"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveCollection);
export default __webpack_public_path__ + "static/media/remove-collection.943c7b80.svg";
export { ForwardRef as ReactComponent };